export const SET_DASHBOARD_STATS = "SET_DASHBOARD_STATS";

export function setDashboardStats(payload) {
  return {
    type: SET_DASHBOARD_STATS,
    payload
  };
}
